import { Injectable } from '@angular/core';

interface Dimension {
	value: number;
	unit: string;
}

@Injectable({ providedIn: 'root' })
export class OfferFormatService {
	formatPeriod(periodStart?: string, periodEnd?: string): string {
		if (!periodStart || !periodEnd) {
			return '';
		}

		const startYear = periodStart.slice(0, 4);
		const endYear = periodEnd.slice(0, 4);
		const startMonth = Number.parseInt(periodStart.slice(-2), 10);
		const endMonth = Number.parseInt(periodEnd.slice(-2), 10);
		const yearDiff = Number.parseInt(endYear, 10) - Number.parseInt(startYear, 10);
		const deltaMonth = endMonth - startMonth + 1 + (yearDiff * 12);

		if (deltaMonth === 12 && startMonth === 1 && endMonth === 12) {
			return `Year ${ startYear }`;
		}
		if (deltaMonth === 6 && (startMonth === 1 || startMonth === 7)) {
			return `Semester ${ startMonth === 1 ? '01' : '02' }/${ startYear }`;
		}
		if (deltaMonth === 3 && startMonth % 3 === 1) {
			const quarter = endMonth === 3 ? '01' : endMonth === 6 ? '02' : endMonth === 9 ? '03' : '04';
			return `Quarter ${ quarter }/${ startYear }`;
		}
		if (deltaMonth === 1) {
			return `Month ${ startMonth.toString().padStart(2, '0') }/${ startYear }`;
		}
		return `${ periodStart } / ${ periodEnd }`;
	}

	formatDimension(dim?: { thickness?: Dimension; width?: Dimension; length?: Dimension }): string {
		if (!dim) {
			return '';
		}
		const { thickness, width, length } = dim;
		const parts = [thickness?.value, width?.value, length?.value]
			.filter((v): v is number => v !== undefined)
			.map(v => Number.parseFloat(v.toString()).toString());
		return parts.join(' x ');
	}

	formatPrice(quantity?: string, unit?: string): string {
		if (!quantity) {
			return '';
		}
		const num = Number.parseFloat(quantity);
		if (Number.isInteger(num)) {
			return unit === 'EUR/t' ? `${ num } €/t` : `${ num }${ unit ?? '' }`;
		}
		const formatted = num.toString();
		return unit === 'EUR/t' ? `${ formatted } €/t` : `${ formatted }${ unit ?? '' }`;
	}
}
